import React from "react";
import {
  Box,
  Divider,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  withStyles,
} from "@material-ui/core";
import { CloseButton, CorporateTypography } from "halifax";
import classNames from "./styles.module.css";

interface Props {
  currentStep: number;
  title: string;
  subtitle: string;
  onClose: () => void;
  showDivider?: boolean;
  isMobile?: boolean;
}

const Header = ({
  currentStep,
  title,
  subtitle,
  onClose,
  showDivider = false,
  isMobile = false,
}: Props): React.ReactElement => {
  const CustomConnector = withStyles({
    root: {
      flex: "0 0 30px !important",
    },
    line: {
      maxWidth: 30,
      minWidth: 30,
    },
  })(StepConnector);
  return (
    <Box
      className={classNames.container}
      style={isMobile ? { paddingLeft: 16, paddingRight: 16 } : undefined}
    >
      <div className={classNames.closeButtonContainer}>
        <CloseButton onClick={onClose} />
      </div>
      <Box className={classNames.stepperRow}>
        <Stepper
          className={classNames.stepper}
          activeStep={currentStep}
          connector={<CustomConnector />}
        >
          <Step>
            <StepLabel>{isMobile ? `` : `TRAVELER `}PROFILE</StepLabel>
          </Step>
          <Step>
            <StepLabel>{isMobile ? `` : `ADDITIONAL `}DETAILS</StepLabel>
          </Step>
        </Stepper>
      </Box>
      <CorporateTypography
        id="onboarding-title"
        variant={isMobile ? "h4" : "h1"}
        fontWeight="light"
        aria-label={`Step ${currentStep + 1} of 2: ${title}`}
      >
        {title}
      </CorporateTypography>
      <CorporateTypography
        id="onboarding-subtitle"
        variant={isMobile ? "body1" : "subtitle2"}
        fontWeight="light"
      >
        {subtitle}
      </CorporateTypography>
      {showDivider && <Divider />}
    </Box >
  );
};

export default Header;
